import { Table, Typography } from "antd";
import { parseUnknownDate } from "../../../helpers/helpers";

const { Text } = Typography;

const defaultDataSource = [
  {
    key: "1",
    serial: 1,
    invoiceNo: "INV123456",
    amount: 200000,
    date: "23-10-2023",
    dueDate: "26-10-2023",
  },
  {
    key: "2",
    serial: 2,
    invoiceNo: "INV456123",
    amount: 500000,
    date: "01-11-2023",
    dueDate: "04-11-2023",
  },
];

const columns = [
  {
    title: "Serial No.",
    dataIndex: "serial",
    key: "serial",
  },
  {
    title: "Invoice No.",
    dataIndex: "invoiceNo",
    key: "invoiceNo",
  },
  {
    title: "Invoice Amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Invoice Date",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Invoice Due Date",
    dataIndex: "dueDate",
    key: "dueDate",
  },
];

const formatToDDMMYYYY = (val) => {
  if (!val) return "-";
  if (typeof val === "string" && /^\d{2}-\d{2}-\d{4}$/.test(val.trim())) {
    return val.trim();
  }
  if (typeof val === "string" && /^\d{4}-\d{2}-\d{2}$/.test(val.trim())) {
    const [y, m, d] = val.trim().split("-");
    return `${d}-${m}-${y}`;
  }
  try {
    const parsed = parseUnknownDate(val);
    if (parsed && /^\d{4}-\d{2}-\d{2}$/.test(parsed)) {
      const [y, m, d] = parsed.split("-");
      return `${d}-${m}-${y}`;
    }
  } catch (e) {
    // fallback
  }
  const dateObj = new Date(val);
  if (!isNaN(dateObj.getTime())) {
    const d = String(dateObj.getDate()).padStart(2, "0");
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const y = dateObj.getFullYear();
    return `${d}-${m}-${y}`;
  }
  return String(val);
};

const InvoiceFormatTable = ({ data }) => {
  const isUploaded = Array.isArray(data) && data.length > 0;

  const dataSource = isUploaded
    ? data.map((row, index) => {
        const rowLower = {};
        Object.entries(row || {}).forEach(([k, v]) => {
          rowLower[String(k).trim().toLowerCase()] = v;
        });
        return {
          key: String(index + 1),
          serial: index + 1,
          invoiceNo:
            rowLower["invoice number"] ||
            rowLower["invoice no."] ||
            rowLower["invoice no"] ||
            row["Invoice Number"] ||
            row["Invoice No."] ||
            "-",
          amount:
            rowLower["invoice amount"] ||
            rowLower["amount"] ||
            row["Invoice Amount"] ||
            "-",
          date: formatToDDMMYYYY(
            rowLower["invoice date"] ||
            rowLower["date"] ||
            row["Invoice Date"]
          ),
          dueDate: formatToDDMMYYYY(
            rowLower["invoice due date"] ||
            rowLower["due date"] ||
            row["Invoice Due Date"]
          ),
        };
      })
    : defaultDataSource;

  return (
    <>
      <Text style={{ display: "block", color: "#40566D", marginBottom: 12, marginTop: 40, fontSize: 14 }}>
        {isUploaded
          ? "Uploaded summary sheet preview:"
          : "Ensure your summary sheet follows this format:"}
      </Text>
      <div className="invoice-format-table">
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={isUploaded && dataSource.length > 5 ? { pageSize: 5, showSizeChanger: false } : false}
          bordered
          scroll={{ x: "max-content" }}
        />
      </div>
    </>
  );
};

export default InvoiceFormatTable;
